/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'company-hub-common.ai.error.common-error.general-error':
    'Atlassian Intelligence can’t provide a response right now. Read more <a>in our support documentation</a>.',
  'company-hub-common.ai.error.common-error.not-enough-content':
    'There isn’t enough content here to summarise. Try again when more content has been added.',
  'company-hub-common.ai.error.common-error.rate-limit':
    'Excessive use has been detected with Atlassian Intelligence. Try again later. Read more <a>in our support documentation</a>.',
  'company-hub-common.ai.error.page-error.aup-violation':
    'Your content might not comply with our Acceptable Use Policy. Please review and refer to our <a>Acceptable Use Policy</a> if needed.',
  'company-hub-common.ai.error.page-error.too-much-content':
    'Atlassian Intelligence can’t generate a summary for you right now, as there is too much content to summarise.',
  'company-hub-common.attachment-size-limit-error.description': 'Attachments must be {size} or less.',
  'company-hub-common.attachment-size-limit-error.learn-more': 'Learn more',
  'company-hub-common.attachment-size-limit-error.title': '{fileName} is too large to upload',
  'company-hub-common.attachment-zero-byte-error.title': '{fileName} is empty (zero bytes)',
  'company-hub-common.attachment-zero-byte.description': 'Attachments must be at least 1 byte of size',
  'company-hub-common.config-panel.new-lozenge-label': 'NEW',
  'company-hub-common.config-panel.panel-close-button.close-label': 'Close configuration panel',
  'company-hub-common.emoji-title.icon.embed': 'Embed',
  'company-hub.common.media-components.media-picker.ui.content.inspiration.text': 'Need inspiration?',
  'company-hub.common.media-components.media-picker.ui.content.placeholder.text': 'Add link from URL',
  'company-hub.common.media-components.unsplash.unsplash-browser.button.text': 'Browse unsplash',
  'company-hub.common.media-components.unsplash.unsplash-browser.error.text':
    'We had trouble accessing this link. Try again.',
  'company-hub.company-hub-common.ui.empty-state.label-placeholder': 'LABEL',
  'company-hub.generic-error-page.description':
    'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
  'company-hub.generic-error-page.heading': "We're on it",
  'custom-sites-extensions.config-panel.add-card-cta': 'Add card',
  'custom-sites-extensions.config-panel.content.label-button.popup.hide-label-button.text': 'Hide label',
  'custom-sites-extensions.config-panel.content.label-button.popup.title': 'Label',
  'custom-sites-extensions.config-panel.content.label-button.title': 'Label',
  'custom-sites-extensions.config-panel.feedback-collector.preamble.first-line':
    'Your input is valuable and allows us to better meet your needs. What could be improved?',
  'custom-sites-extensions.config-panel.feedback-collector.summary-placeholder':
    'What works well? What could be improved?',
  'custom-sites-extensions.config-panel.feedback-section.preamble': 'Your feedback helps us improve.',
  'custom-sites-extensions.config-panel.feedback-section.share-feedback-button.text-extension':
    '{type, select, Cards {Give feedback on Cards} Carousel {Give feedback on Carousel} Linksmenu {Give feedback on Links menu} Spotlight {Give feedback on Spotlight} Section {Give feedback on Section} Customsearch {Give feedback on Custom Search} Companyhub {Give feedback on Company hub} other {Share your thoughts}}',
  'custom-sites-extensions.config-panel.render-variant.dropdown.label': 'Card type',
  'custom-sites-extensions.config-panel.render-variant.dropdown.option.label.dynamic': 'Dynamic',
  'custom-sites-extensions.config-panel.render-variant.dropdown.option.label.manual': 'Manual',
  'custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-preamble':
    'We’re having trouble loading these cards.',
  'custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-support':
    'Reload to try again.',
  'custom-sites-extensions.link-cards.card.collapse.label': 'Collapse card',
  'custom-sites-extensions.link-cards.card.expand.label': 'Expand card',
  'custom-sites-extensions.link-cards.card.image.section.label': 'Image',
  'custom-sites-extensions.link-cards.card.remove.card.label': 'Remove card',
  'custom-sites-extensions.link-cards.card.title': 'Card {order}',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.down': 'down',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.up': 'up',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.down.label':
    'Move down',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.up.label':
    'Move up',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.reorder': 'reorder',
  'custom-sites-extensions.link-cards.description.ai-disclaimer': 'Content quality may vary',
  'custom-sites-extensions.link-cards.description.button.suggest-description.label': 'Suggest Description',
  'custom-sites-extensions.link-cards.description.link.label.ai': 'Learn more about Atlassian AI',
  'custom-sites-extensions.link-cards.error-states.no-data.description-text':
    'Try deleting this macro and creating a new one.',
  'custom-sites-extensions.link-cards.error-states.no-data.header-text': 'No data to display',
  'custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.description': 'Refresh the page and try again',
  'custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.title': 'We can’t upload your image',
  'custom-sites-extensions.link-cards.image-failed-to-load': 'Image failed to load',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2': 'Alignment',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.center': 'Center',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.left': 'Left',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.right': 'Right',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.all-cards.label':
    'all cards',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.each-card.label':
    'each card',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.all-cards.label':
    'All cards',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.each-card.label':
    'Each card',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.v2.item.no-segmentation.label':
    'None',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.info-label':
    'Add target groups for each card',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-groups-text-label': 'Target groups',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-groups-text-label.v2':
    'Target audience groups',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-text-label': 'Target content for',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-text.v2.label': 'Target audience',
  'custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.info-icon-label-v2':
    'Choose which Confluence user groups will see your cards',
  'custom-sites-extensions.link-cards.warning': 'Warning icon for image failed to load',
  'custom-sites-extensions.link.cards.image.upload.error.flag.description': 'Refresh the page and try again.',
  'custom-sites-extensions.link.cards.image.upload.error.flag.title': 'We can’t upload your image',
  'custom-sites-extensions.links-menu.corner.style': 'Corner style',
  'custom-sites-extensions.links-menu.corner.style-round': 'Round',
  'custom-sites-extensions.links-menu.corner.style-square': 'Square',
  'custom-sites-extensions.refined.unsplash.search.placeholder': 'Browse Unsplash',
  'custom-sites-extensions.shared-components.item.collapse.label':
    '{itemLabel, select, card {Collapse card} frame {Collapse frame} other {Collapse card}}',
  'custom-sites-extensions.shared-components.item.expand.label':
    '{itemLabel, select, card {Expand card} frame {Expand frame} other {Expand card}}',
  'custom-sites-extensions.shared-components.item.remove.label':
    '{itemLabel, select, card {Remove card} frame {Remove frame} other {Remove card}}',
  'custom-sites-extensions.shared-components.item.title':
    '{itemLabel, select, card {Card {order}} frame {Frame {order}} other {Card {order}}}',
  'custom-sites-extensions.shared-components.link-picker.clear-icon-label': 'Clear link selection',
  'custom-sites-extensions.shared-components.link-picker.popup-placeholder-text': 'Add any link',
  'custom-sites-extensions.shared-components.unsplash-search.upload.error.description':
    'Refresh the page and try again',
  'custom-sites-extensions.shared-components.unsplash-search.upload.error.title': 'Image failed to load',
  'custom-sites-extensions.spotlight.button-label.placeholder': 'View',
  'custom-sites-extensions.spotlight.spotlight-config-panel.button-heading': 'Button',
  'custom-sites-extensions.spotlight.spotlight-config-panel.button-text-placeholder': 'View',
  'custom-sites-extensions.spotlight.spotlight-config-panel.dark-button-style-label': 'Alternative',
  'custom-sites-extensions.spotlight.spotlight-config-panel.delete-icon-label': 'Delete',
  'custom-sites-extensions.spotlight.spotlight-config-panel.light-button-style-label': 'Default',
  'custom-sites-extensions.spotlight.spotlight-config-panel.mdia-picker-helper-message':
    'Choose high resolution images 1200px or wider for best results.',
  'custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-button-label': 'Choose media',
  'custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-content-title': 'Media',
  'custom-sites-extensions.unsplash-search.default-image-picker.no-image': 'No image',
  'custom-sites-extensions.unsplash.background-img.default.label': 'Default background image for upload previewer',
  'custom-sites-extensions.unsplash.delete.image.text': 'Remove image',
  'custom-sites-extensions.unsplash.error.bad-request-message':
    'We can’t get a response from Unsplash. Refresh and try again.',
  'custom-sites-extensions.unsplash.error.rate-limited-message':
    'We can’t get a response from Unsplash. Wait a moment, then try again.',
  'custom-sites-extensions.unsplash.legal':
    'By using images from Unsplash, you agree to their {unsplashLicenseLink} and {unsplashTermsOfServiceLink}.',
  'custom-sites-extensions.unsplash.license': 'licence',
  'custom-sites-extensions.unsplash.search.error.no-network-message': 'We’ve lost the connection. Try again.',
  'custom-sites-extensions.unsplash.search.load.more.unsplash.photos': 'Load more',
  'custom-sites-extensions.unsplash.search.no.more.results.to.load.text': 'No more matches try another search',
  'custom-sites-extensions.unsplash.search.no.results.text': 'Nothing matches your search',
  'custom-sites-extensions.unsplash.terms.of.service.': 'Terms of Service',
  'custom-sites-extensions.unsplash.upload.label': 'Upload',
  'custom-sites-extensions.unsplash.upload.text': 'Upload',
  label: 'Number of cards',
};
